import api from '../httpClient';
import { ANSWER_REFERENCE_TIMEOUT_MS, type AnswerReferenceMap } from 'utils/answerReferences';
import { courseRuntimeUrl } from './courseRuntimeContext';

export type AnswerReferenceSource = { flowRunId: number } | { quizAttemptId: number };

// Learner-bound REQ-106 values for one module item. The server derives keys from
// the item's authored fields; the client never chooses which answers to read.
export const answerReferences = {
  get: (flowName: string, flowItemId: number, source: AnswerReferenceSource) =>
    api.get<{ references: AnswerReferenceMap; digest?: string }>(
      courseRuntimeUrl(`/api/flows/${encodeURIComponent(flowName)}/answer-references/${flowItemId}/`),
      {
        params: 'flowRunId' in source ? { flow_run: source.flowRunId } : { quiz_attempt: source.quizAttemptId },
        // Optional wording must never hold a question indefinitely.
        timeout: ANSWER_REFERENCE_TIMEOUT_MS,
      },
    ).then(({ data }) => ({ references: data.references ?? {}, digest: data.digest })),
};
